import { render, staticRenderFns } from "./BindInviterModal.vue?vue&type=template&id=4c58c5e4&scoped=true"
import script from "./BindInviterModal.vue?vue&type=script&lang=js"
export * from "./BindInviterModal.vue?vue&type=script&lang=js"
import style0 from "./BindInviterModal.vue?vue&type=style&index=0&id=4c58c5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c58c5e4",
  null
  
)

export default component.exports